// extracted by mini-css-extract-plugin
export var headerImage = "DetailsImg-module--header-image--um+k5";